export const myTasksFilters = {
  propertyName: 'TaskStatusId',
  values: [1, 2], // STATUS != (‘Completed’ OR 'Voided’)
};
